module.exports = __webpack_public_path__ + "static/media/icon_unsubscribe.58d69e22.svg";